// src/pages/dashboard/wallet-detail/shared/use-wallet-metadata.tsx
import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { 
  BitcoinIcon, 
  EthereumIcon, 
  TetherIcon,
  TronIcon,
  BinanceIcon
} from '../../../../components/ui/Icons';

export function useWalletMetadata() {
  // Función para obtener icono según la moneda
  const getCurrencyIcon = (currencyName: string | undefined) => {
    if (!currencyName) return null;
    
    switch (currencyName.toUpperCase()) {
      case 'BTC':
        return <BitcoinIcon size={32} color="#B3A369" />;
      case 'ETH':
        return <EthereumIcon size={32} color="#B3A369" />;
      case 'USDT_ERC20':
      case 'USDT':
        return <TetherIcon size={32} color="#26A17B" />;
      case 'USDT_TRON':
        return <TetherIcon size={32} color="#26A17B" />;
      case 'TRX':
        return <TronIcon size={32} color="#FF060A" />;
      case 'BNB':
        return <BinanceIcon size={32} color="#F3BA2F" />;
      case 'USDT_BEP20':
        return <BinanceIcon size={36} color="#2f99f3" />;
      case 'USD':
        return <div className="scale-150"><ReactCountryFlag countryCode="US" svg /></div>;
      case 'EUR':
        return <div className="scale-150"><ReactCountryFlag countryCode="EU" svg /></div>;
      case 'GBP':
        return <div className="scale-150"><ReactCountryFlag countryCode="GB" svg /></div>;
      default:
        return null;
    }
  };

  // Función para obtener nombre completo de la moneda
  const getCurrencyName = (currencyName: string | undefined) => {
    if (!currencyName) return '';
    
    switch (currencyName?.toUpperCase()) {
      case 'BTC':
        return 'Bitcoin';
      case 'ETH':
        return 'Ethereum';
      case 'USDT_ERC20':
        return 'USDT (ERC20)';
      case 'USDT_TRON':
        return 'USDT TRC20';
      case 'TRX':
        return 'TRON';
      case 'BNB':
        return 'Binance Coin';
      case 'USDT_BEP20':
        return 'USDT (BEP20)'
      case 'USD':
        return 'US Dollar';
      case 'EUR':
        return 'Euro';
      case 'GBP':
        return 'British Pound';
      default:
        return currencyName || '';
    }
  };

  return {
    getCurrencyIcon,
    getCurrencyName
  };
}